<template>
    <el-dialog :visible.sync="openDialog" width="800px" top="50px" class="add-edit-materia"
         :title="title" :close-on-click-modal="false">
        <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
            <el-row>
                <el-col :span="24" style="margin-bottom:10px">
                    <el-descriptions :column="3" :border="true" :colon="false" size="mini">
                        <el-descriptions-item labelClassName="my-descriptions-label" label="物料名称">
                            {{form.name}}
                        </el-descriptions-item>
                        <el-descriptions-item labelClassName="my-descriptions-label" label="物料编码">
                            {{form.code}}
                        </el-descriptions-item>
                        <el-descriptions-item labelClassName="my-descriptions-label" label="物料类别">
                            {{form.classifyName}}
                        </el-descriptions-item>
                        <el-descriptions-item labelClassName="my-descriptions-label" label="规格">
                            {{form.sspace}}
                        </el-descriptions-item>
                        <el-descriptions-item labelClassName="my-descriptions-label" label="型号">
                            {{form.model}}
                        </el-descriptions-item>
                        <el-descriptions-item labelClassName="my-descriptions-label" label="图号">
                            {{form.figueNumber}}
                        </el-descriptions-item>
                        <el-descriptions-item labelClassName="my-descriptions-label" label="单位">
                            {{form.unit}}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="需求日期" prop="xqDate">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.xqDate"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="需求数量" prop="num">
                        <el-input @keyup.native="xqNumInput" v-model="form.num" placeholder="请输入需求数量"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="询价特殊备注" prop="bcExplain">
                        <el-input type="textarea" :rows="3" maxlength="300" v-model="form.bcExplain" placeholder="请输入行备注明" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="附件" prop="src">
                        <el-upload class="upload-demo" :action="upload()" :show-file-list="false"
                            accept=".xls,.xlsx,.doc,.docx,.pdf,application/msword" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" :headers="{'Authentication':token()}">
                            <el-input style="width:100%" v-model="form.src" placeholder="点击文本框上传" readonly slot="trigger" />
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {
    inquiryDetailList,
    addInquiryDetail,
    editInquiryDetail,
    delInquiryDetail,
    exportInquiryDetail,
} from '@/api/srm/inquiryDetail.js'
import { queryAllDeptList } from '@/api/system/dept.js'
export default {
    props:['orderInfo'],
    computed:{
    },
    data(){
        return {
            title: "",
            form: {},
            openDialog: false,
            rules: {
                num: [{ required: true, message: '请输入需求数量', trigger: 'blur' }],
                xqDate: [{ required: true, message: '请输入需求日期', trigger: 'blur' }],
            },
            stockOrgArr:[],
        }
    },
    mounted(){
        this.queryAllDeptList();
    },
    methods:{
        async queryAllDeptList() {
            let _this = this;
            const {
                data: res
            } = await queryAllDeptList({stockOrg:'是'})
            if (res.code == 0) {
                _this.stockOrgArr = res.data || [];
            }
        },
        // 表单重置
        reset: function() {
            this.form = {
                id: undefined,
                createUser: this.$store.getters['user/user'].id,
                hId: this.$route.query.hId, // 订单id
                xqDate: undefined,
                num: undefined,
                bcExplain: undefined,
                src: undefined,
                requestNo:'',
                requestState:'',
                requestStandard:'',
                requestSpec:'',
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        submitForm() {
            let _this = this;
            _this.$refs['form'].validate((valid) => {
                if (valid) {

                    let curForm = {
                        createUser: this.$store.getters['user/user'].id,    //操作人
                        orderId: this.$route.query.hId, // 订单id
                        commodityId:_this.form.goodsId,  // 物料id
                        xqDate: _this.form.xqDate,
                        num: _this.form.num,
                        bcExplain: _this.form.bcExplain,
                        src: _this.form.src,
                        requestNo: _this.form.requestNo,
                        requestState: _this.form.requestState,
                        requestStandard: _this.form.requestStandard,
                        requestSpec: _this.form.requestSpec,
                    }
                    if (_this.form.id != undefined) {
                        curForm['id'] = _this.form.id;
                        editInquiryDetail(curForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                this.$emit('callback', {type:'getlist'});
                            } else {
                            }
                        });
                    } else {
                        addInquiryDetail(curForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                this.$emit('callback', {type:'getlist'});
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            });
        },
        handleAdd: function() {
            this.reset();
            this.title = "新增";
            this.openDialog = true;
        },
        handleEdit: function(row,title) {
            console.log(row)
            this.reset();
            this.title = title;
            this.form = Object.assign({...this.form,...JSON.parse(JSON.stringify(row))}); //直接赋值 表格数据 也会改变 要深拷贝复制
            this.openDialog = true;
        },
        handleAvatarSuccess(res, file) {
            if (res.code == 0) {
                this.$success(res.msg);
                if (this.form.src != "" && this.form.src != undefined) {
                    //如果修改附件 则删除原来的附件
                    if (this.form.src != res.data.url) {
                        this.delFile(this.form.src);
                    }
                }
                this.form.src = res.data.url;
                console.log(this.form.src)
            }
        },
        beforeAvatarUpload(file) {
            //      let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$fail('上传附件大小不能超过 2MB!');
            }
            return isLt2M;
        },
        // 限制只能输入两位小数得数字
        fixedPriceChange(name){
            let curVal = this.form[name];
            curVal = curVal.replace(/(^\s*)|(\s*$)/g, "");
            const reg = /[^\d.]/g;
            // 只能是数字和小数点，不能是其他输入
            curVal = curVal.replace(reg, "");
            // 保证第一位只能是数字，不能是点
            curVal = curVal.replace(/^\./g, "");
            // 小数只能出现1位
            curVal = curVal
                .replace(".", "$#$")
                .replace(/\./g, "")
                .replace("$#$", ".");
            // 小数点后面保留2位
            curVal = curVal.replace( /^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
            this.form[name] = curVal;
        },
        xqNumInput() {
            if(this.form.num){
                this.form.num = this.form.num.replace(/[^\.\d]/g, '')
                this.form.num = this.form.num.replace('.', '')
            }
        }
    }
}
</script>
<style lang="scss">
    .add-edit-materia{
        .el-form-item__label{
            color:#999;
        }
    }
</style>


